import permissions from "app/permissions";
import { administrationRequests } from "api/administrationApi";
import React from "react";
import { Button, Datagrid, FunctionField, ReferenceField, SimpleList, TextField } from "react-admin";
import { useNavigate } from "react-router-dom";
import SecuredComponent from "server/security/SecuredComponent";
import EditIcon from "@mui/icons-material/Edit";
import { FromWeekToWeekChoices, WeekDaysChoices, WeekTypeChoices } from "utils/choices";
import { useMediaQuery } from "@mui/system";
import { MobileListRow } from "features/MobileListRow";
import { FOR_UPDATE, MOBILE_BREAKPOINT, StudentServicePath, WEEKLY_STREAM_SCHEDULE } from "utils/constants";
import { EmptyList } from "server/components";
import { settings } from "app";

const StreamsWeeklyScheduleTable = () => {
  const isMobile = useMediaQuery(MOBILE_BREAKPOINT);
  const navigate = useNavigate();
  return isMobile ? (
    <SimpleList
      empty={<EmptyList />}
      linkType={false}
      sx={settings.style.mobileList}
      primaryText={record => (
        <div>
          <MobileListRow
            fields={[
              {
                label: "Дисциплина",
                value: (
                  <ReferenceField
                    source="disciplineId"
                    reference={administrationRequests.getDisciplinesSelect()}
                    sortable={false}
                  >
                    <TextField source="name" />
                  </ReferenceField>
                ),
              },
            ]}
          />
          <MobileListRow fields={[{ label: "Учебни планове", value: record.curriculumsNames.join(", ") }]} />
        </div>
      )}
      secondaryText={record => (
        <div>
          <MobileListRow fields={[{ label: "Курс", value: record.courses?.join(", ") }]} />
          <MobileListRow
            fields={[{ label: "Ден", value: WeekDaysChoices.find(d => d.id === record.weekDay)?.name }]}
          />
          <MobileListRow
            fields={[
              {
                label: "Час",
                value: `${record.startTime.slice(0, 5)} - ${record.endTime.slice(0, 5)}`,
              },
            ]}
          />
          <MobileListRow
            fields={[
              {
                label: "Зала",
                value: (
                  <ReferenceField
                    source="roomId"
                    reference={administrationRequests.getRoomsSelect()}
                    sortable={false}
                  >
                    <FunctionField render={record => `${record.roomName} ${record.buildingName}`} />
                  </ReferenceField>
                ),
              },
            ]}
          />
          <MobileListRow
            fields={[
              {
                label: "Тип занятие",
                value: (
                  <ReferenceField
                    source="classTypeId"
                    reference={administrationRequests.getRoomClassTypesSelect()}
                    sortable={false}
                  >
                    <TextField source="name" />
                  </ReferenceField>
                ),
              },
            ]}
          />
          <MobileListRow
            fields={[{ label: "Тип седмица", value: WeekTypeChoices.find(d => d.id === record.weekType)?.name }]}
          />
          <MobileListRow
            fields={[
              { label: "От", value: FromWeekToWeekChoices.find(d => d.id === record.fromWeek)?.name },
              { label: "До", value: FromWeekToWeekChoices.find(d => d.id === record.toWeek)?.name },
            ]}
          />
        </div>
      )}
      tertiaryText={record => (
        <SecuredComponent permission={permissions.canUpdateEverythingInWeeklySchedules}>
          <Button
            onClick={() =>
              navigate(`/${StudentServicePath}${FOR_UPDATE}/${WEEKLY_STREAM_SCHEDULE}`, {
                state: { groupId: record.groupId, disciplineId: record.disciplineId },
              })
            }
            label=""
            color="primary"
          >
            <EditIcon />
          </Button>
        </SecuredComponent>
      )}
    />
  ) : (
    <Datagrid
      rowClick={false}
      bulkActionButtons={false}
    >
      <ReferenceField
        source="disciplineId"
        reference={administrationRequests.getDisciplinesSelect()}
        label="Дисциплина"
        sortable={false}
      >
        <TextField source="name" />
      </ReferenceField>

      <TextField
        source="curriculumsNames"
        label="Учебни планове"
        sortable={false}
      />
      <FunctionField
        label="Курс"
        render={record => record.courses?.join(", ")}
      />
      <FunctionField
        label="Ден"
        render={record => WeekDaysChoices.find(d => d.id === record.weekDay)?.name}
      />
      <FunctionField
        label="Час"
        render={record => `${record.startTime.slice(0, 5)} - ${record.endTime.slice(0, 5)}`}
      />
      <ReferenceField
        source="roomId"
        reference={administrationRequests.getRoomsSelect()}
        label="Зала"
        sortable={false}
      >
        <FunctionField render={record => `${record.roomName} ${record.buildingName}`} />
      </ReferenceField>

      <ReferenceField
        source="classTypeId"
        reference={administrationRequests.getRoomClassTypesSelect()}
        label="Тип занятие"
        sortable={false}
      >
        <TextField source="name" />
      </ReferenceField>
      <FunctionField
        label="Тип седмица"
        render={record => WeekTypeChoices.find(d => d.id === record.weekType)?.name}
      />
      <FunctionField
        label="От"
        render={record => FromWeekToWeekChoices.find(d => d.id === record.fromWeek)?.name}
      />
      <FunctionField
        label="До"
        render={record => FromWeekToWeekChoices.find(d => d.id === record.toWeek)?.name}
      />
      <FunctionField
        label=""
        textAlign="center"
        render={record => (
          <SecuredComponent permission={permissions.canUpdateEverythingInWeeklySchedules}>
            <Button
              onClick={() =>
                navigate(`/${StudentServicePath}${FOR_UPDATE}/${WEEKLY_STREAM_SCHEDULE}`, {
                  state: { groupId: record.groupId },
                })
              }
              variant="contained"
              label="Редактирай"
              color="primary"
            >
              <EditIcon />
            </Button>
          </SecuredComponent>
        )}
      />
    </Datagrid>
  );
};

export default StreamsWeeklyScheduleTable;
